const COPY_SUFFIX_REGEX = /\s*\(Copy\)\s*$/;
const UNDERSCORE_NUM_SUFFIX_REGEX = /_(\d+)$/;

export function getBaseName(name: string): string {
  let result = name ?? '';
  let changed = true;
  while (changed) {
    changed = false;
    if (COPY_SUFFIX_REGEX.test(result)) {
      result = result.replace(COPY_SUFFIX_REGEX, '');
      changed = true;
    }
    if (UNDERSCORE_NUM_SUFFIX_REGEX.test(result)) {
      result = result.replace(UNDERSCORE_NUM_SUFFIX_REGEX, '');
      changed = true;
    }
  }
  return result.trim();
}

export function generateCopyName(name: string, existingNames: string[]): string {
  const baseName = getBaseName(name);
  const usedNumbers = new Set<number>();

  for (const existing of existingNames) {
    if (existing == null) continue;
    const existingBase = getBaseName(existing);
    if (existingBase !== baseName) continue;

    const match = existing.match(UNDERSCORE_NUM_SUFFIX_REGEX);
    if (match) {
      usedNumbers.add(parseInt(match[1], 10));
    } else if (existing.trim() === baseName) {
      usedNumbers.add(1);
    }
  }

  let next = 2;
  while (usedNumbers.has(next)) {
    next++;
  }

  return `${baseName}_${next}`;
}
